import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import uuid from 'uuid-random';
import {
  getLevelInfo,
  ReturnLevelIcon,
  getLevelBackground,
  getLevelTaxColour,
  formatWithThousandsSeparator
} from '../../helpers/utils';

import SectionLayout from '../SectionLayout';
import { ReputationSelectors } from '../../ducks/reputation';
import { dataRatingsAdapter } from '../dataRatingsAdapter';
import EmptyStateScore from '../EmptyStateScore';
import Comment from '../Comment';
import {
  Container,
  Icon,
  MainArea,
  LeftSide,
  ContainerRaitings,
  RightSide,
  ContainerValue,
  BottomSheetContainer,
  BottomSheetTitle,
  CommentsContainer,
  TitleContainer,
  BajadaContainer,
  InfoLevel,
  LineDiv,
  ContainerSectionTax,
  TextDiv,
  ButtonDiv,
  Secondary,
  SpanTex,
  HeaderSectionContainer,
  MobileBajadaContainer,
  ContainerValueMobile,
  TextDivIntegrador,
  ContainerSectionTaxIntegrador
} from './styles';
import './buttonSheetStyles.css';

const PublisherTaxResponseSection = ({
  device,
  reloadDispatch,
  responseRate,
  error,
  empty,
  sendCustomTrackingInfo,
  isIntegrator
}) => {
  const { t } = useTranslation();
  const isMobile = device === 'mobile';
  const [ratingsData, setRatingsData] = useState({});
  const [, setProgressBarData] = useState([]);
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const { ratings, customersComments } = useSelector(ReputationSelectors.getReputationState);

  const { responseTime, postingContent, attention, recommendYou, notRespondedCount } = ratingsData;

  useEffect(() => {
    if (ratings) setRatingsData(dataRatingsAdapter(ratings));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratings]);

  useEffect(() => {
    setProgressBarData([
      { value: postingContent },
      { value: responseTime },
      { value: attention },
      { value: recommendYou }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratingsData]);

  const handleClickInteresados = () => {
    window.location.assign(`${window.location.origin}${t('panel.interesados.url')}?feedback=filter`);
    sendCustomTrackingInfo({
      event: 'select_content',
      content_type: 'Estadisticas - Reputación',
      item_id: 'Pedir Calificación'
    });
  };

  const handleClickInteresadosNotRead = () => {
    window.location.assign(`${window.location.origin}${t('panel.interesados.url')}?filter=notRead`);
    sendCustomTrackingInfo({
      event: 'select_content',
      content_type: 'Estadisticas - Reputación',
      item_id: 'Responder consultas'
    });
  };

  const getTopEmptyState = () => {
    if (device === 'mobile') return '20px';
    if (device === 'desktop') return '0px';
    return '30px';
  };

  return (
    <SectionLayout
      data-panel='panel-estadisticas-ratings'
      marginTop='0px'
      paddingBottom={notRespondedCount ? '24' : null}
    >
      {device === 'desktop' && (
        <Container>
          {!error && device === 'desktop' ? (
            <MainArea device={device} notRespondedCount={notRespondedCount}>
              <LeftSide device={device} data-panel='ratings-container-leftSide'>
                <TitleContainer>{t('panel.reputacion.tax.title')}</TitleContainer>
                <BajadaContainer>
                  {responseRate.contactedResponses !== null && responseRate.totalResponses !== null && !empty
                    ? t('panel.reputacion.tax.metrica1.title')
                    : t('panel.reputacion.tax.metrica1.title.nodata')}
                </BajadaContainer>
              </LeftSide>

              <RightSide device={device} data-panel='ratings-container-rightSide'>
                <InfoLevel
                  background={getLevelBackground(responseRate.level || 0)}
                  color={getLevelTaxColour(responseRate.level || 0)}
                >
                  <Icon data-panel=''>{ReturnLevelIcon(responseRate.level || 0)}</Icon>
                  <span>{t(getLevelInfo(responseRate.level || 0))}</span>
                </InfoLevel>

                <ContainerRaitings device={device}>
                  <ContainerValue data-panel='contact-value'>
                    {empty === false && responseRate.contactedResponses !== null && responseRate.totalResponses !== null
                      ? `${formatWithThousandsSeparator(
                          responseRate.contactedResponses
                        )}/${formatWithThousandsSeparator(responseRate.totalResponses)}`
                      : ''}
                  </ContainerValue>
                </ContainerRaitings>
              </RightSide>

              {isMobile && (
                <BottomSheet
                  open={openBottomSheet}
                  onDismiss={() => setOpenBottomSheet(false)}
                  snapPoints={({ maxHeight }) => [maxHeight / 1.12]}
                  header={React.createElement(
                    'div',
                    {},
                    <BottomSheetTitle data-panel='ratings-bottomSheet-title'>
                      {t('panel.estadisticas.ratings.moreComments.title')}
                    </BottomSheetTitle>
                  )}
                >
                  <BottomSheetContainer>
                    <CommentsContainer height='429px' data-panel='ratings-bottomSheet-container'>
                      {customersComments &&
                        customersComments.map(customerComment => (
                          <Comment key={uuid()} customerComment={customerComment} keyId={uuid()} />
                        ))}
                    </CommentsContainer>
                  </BottomSheetContainer>
                </BottomSheet>
              )}
            </MainArea>
          ) : (
            <EmptyStateScore
              withSpacing={device === 'desktop'}
              height={isMobile ? '160px' : '115px'}
              top={getTopEmptyState()}
              callback={reloadDispatch}
              text={t('panel.reputacion.tax.title')}
            />
          )}
          {!error && device === 'desktop' && (
            <>
              {isIntegrator === false && <LineDiv />}

              {isIntegrator === false && (
                <ContainerSectionTax>
                  <TextDiv>
                    {t('panel.reputacion.tax.metrica2.title')}
                    <SpanTex>{formatWithThousandsSeparator(responseRate.unreadQueries) || '-'}</SpanTex>
                  </TextDiv>
                  <ButtonDiv>
                    <Secondary onClick={handleClickInteresadosNotRead} disabled={!responseRate.unreadQueries}>
                      {t('panel.reputacion.tax.cta2')}
                    </Secondary>
                  </ButtonDiv>
                </ContainerSectionTax>
              )}

              <LineDiv />
              <ContainerSectionTax>
                <TextDiv>
                  {t('panel.reputacion.tax.metrica3.title')}
                  <SpanTex>{formatWithThousandsSeparator(responseRate.interestedWithoutQualification) || '-'}</SpanTex>
                </TextDiv>
                <ButtonDiv>
                  <Secondary onClick={handleClickInteresados} disabled={!responseRate.interestedWithoutQualification}>
                    {t('panel.reputacion.tax.cta1')}
                  </Secondary>
                </ButtonDiv>
              </ContainerSectionTax>

              {isIntegrator && (
                <>
                  <LineDiv />
                  <ContainerSectionTaxIntegrador>
                    <TextDivIntegrador>{t('panel.reputacion.tax.integrador.text')}</TextDivIntegrador>
                  </ContainerSectionTaxIntegrador>
                </>
              )}
            </>
          )}
        </Container>
      )}

      {!error && device !== 'desktop' && (
        <Container>
          <HeaderSectionContainer>
            <TitleContainer>{t('panel.reputacion.tax.title')}</TitleContainer>
            <InfoLevel
              background={getLevelBackground(responseRate.level || 0)}
              color={getLevelTaxColour(responseRate.level || 0)}
            >
              <Icon data-panel=''>{ReturnLevelIcon(responseRate.level || 0)}</Icon>
              <span>{t(getLevelInfo(responseRate.level || 0))}</span>
            </InfoLevel>
          </HeaderSectionContainer>

          <MobileBajadaContainer>{t('panel.reputacion.tax.metrica1.title')}</MobileBajadaContainer>
          <ContainerValueMobile>
            {responseRate.contactedResponses !== null && responseRate.totalResponses !== null && !empty
              ? `${formatWithThousandsSeparator(responseRate.contactedResponses)}/${formatWithThousandsSeparator(
                  responseRate.totalResponses
                )}`
              : ''}
          </ContainerValueMobile>

          <LineDiv />
          {isIntegrator === false && (
            <MobileBajadaContainer>
              {' '}
              {t('panel.reputacion.tax.metrica2.title')}
              <SpanTex>{formatWithThousandsSeparator(responseRate.unreadQueries) || '-'} </SpanTex>
            </MobileBajadaContainer>
          )}
          {isIntegrator === false && (
            <MobileBajadaContainer>
              <Secondary device={device} onClick={handleClickInteresadosNotRead} disabled={!responseRate.unreadQueries}>
                {t('panel.reputacion.tax.cta2')}
              </Secondary>
            </MobileBajadaContainer>
          )}
          {isIntegrator === false && <LineDiv />}

          <MobileBajadaContainer>
            {' '}
            {t('panel.reputacion.tax.metrica3.title')}
            <SpanTex>{formatWithThousandsSeparator(responseRate.interestedWithoutQualification) || '-'}</SpanTex>
          </MobileBajadaContainer>

          <MobileBajadaContainer>
            <Secondary
              device={device}
              onClick={handleClickInteresados}
              disabled={!responseRate.interestedWithoutQualification}
            >
              {t('panel.reputacion.tax.cta1')}
            </Secondary>
          </MobileBajadaContainer>

          {isIntegrator === true && <LineDiv />}

          {isIntegrator === true && (
            <MobileBajadaContainer>
              <p style={{ width: device === 'desktop' ? '326px' : '95%', whiteSpace: 'pre-line', fontWeight: '700' }}>
                {t('panel.reputacion.tax.integrador.text')}
              </p>
            </MobileBajadaContainer>
          )}
        </Container>
      )}

      {error && device !== 'desktop' && (
        <EmptyStateScore
          withSpacing={device === 'desktop'}
          height={isMobile ? '160px' : '115px'}
          callback={reloadDispatch}
          text={t('panel.reputacion.tax.title')}
        />
      )}
    </SectionLayout>
  );
};

export default PublisherTaxResponseSection;
